import React, {useState} from 'react';

function UrlForm() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let url = params.get('url');
    const [value, setValue] = useState(url)
    return (
        <div className="w-full">
            <form action="/" className="w-full">
                <input
                    className="w-2/3 mr-4 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="username" type="text" name={"url"} placeholder="http://localhost:8080/actuator/startup" value={value} onChange={e => setValue(e.target.value)}
                />
                <button type="submit"
                        className={'bg-transparent hover:bg-purple-700 text-purple-700 hover:text-white py-1 px-4 border border-purple-500 hover:border-transparent rounded'}>Analyze
                </button>
            </form>
        </div>
    );
}

export default UrlForm;
